import { api } from "boot/axios";
import { LocalStorage } from "quasar";
import useTools from "src/use/tools";

export function asOf({ commit }) {
  return new Promise((resolve, reject) => {
    api
      .get("/tools/as-of/")
      .then((response) => {
        commit("updateAsOf", response.data.as_of);
        resolve(response.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}

export function marketStatus({ commit }) {
  return new Promise((resolve, reject) => {
    api
      .get("/tools/market-status/")
      .then((response) => {
        commit("updateMarketStatus", response.data);
        resolve(response.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}

export function marketStatusNew({ commit }) {
  return new Promise((resolve, reject) => {
    useTools()
      .marketStatusNew()
      .then((response) => {
        commit("updateMarketStatusNew", response.data);
        LocalStorage.set("as_of_live", response.data.as_of_live);
        LocalStorage.set("as_of_live_unix", response.data.as_of_live_unix);
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
